if (!customElements.get('ugc-card')) {
  customElements.define(
    'ugc-card',
    class UgcCard extends HTMLElement {
      constructor() {
        super();
        this.video = this.querySelector('video');
        this.muteBtn = this.querySelector('.ugc-card__mute-btn');
        this.playBtn = this.querySelector('.ugc-card__play-btn');
        
        if (this.video && this.muteBtn && this.playBtn) {
          this.initControls();
        }
      }

      initControls() {
        // Mute/Unmute toggle
        this.muteBtn.addEventListener('click', () => {
          const isMuted = this.muteBtn.dataset.muted === 'true';
          this.video.muted = !isMuted;
          this.muteBtn.dataset.muted = !isMuted;
          
          const muteIcon = this.muteBtn.querySelector('.ugc-card__icon--mute');
          const soundIcon = this.muteBtn.querySelector('.ugc-card__icon--sound');
          
          if (isMuted) {
            muteIcon.style.display = 'none';
            soundIcon.style.display = 'block';
            this.muteBtn.setAttribute('aria-label', 'Mute');
          } else {
            muteIcon.style.display = 'block';
            soundIcon.style.display = 'none';
            this.muteBtn.setAttribute('aria-label', 'Unmute');
          }
        });
        
        // Play/Pause toggle
        this.playBtn.addEventListener('click', () => {
          const isPlaying = this.playBtn.dataset.playing === 'true';
          
          if (isPlaying) {
            this.video.pause();
          } else {
            this.video.play();
          }
          
          this.playBtn.dataset.playing = !isPlaying;
          
          const pauseIcon = this.playBtn.querySelector('.ugc-card__icon--pause');
          const playIcon = this.playBtn.querySelector('.ugc-card__icon--play');
          
          if (isPlaying) {
            pauseIcon.style.display = 'none';
            playIcon.style.display = 'block';
            this.playBtn.setAttribute('aria-label', 'Play');
          } else {
            pauseIcon.style.display = 'block';
            playIcon.style.display = 'none';
            this.playBtn.setAttribute('aria-label', 'Pause');
          }
        });
      }
    }
  );
}
